
export const URL = "https://www.schmidlin.ch/configurator/";
export const URL_PDF = "https://www.schmidlin.ch/configuration/pdf";
export const VERSION = "v0.13";
export const GOOGLE_ANALYTICS = "341651092";



// WEBPACK FOOTER //
// ./src/config/Config.js